import { useMutation } from '@tanstack/react-query';
import { useGetCurrentBoardId } from 'entities/user/api/hooks/useGetCurrentBoardId';
import { postPdfs } from '../requests';
import type { PostPdfsRequestType } from '../types';

export type UsePostPdfsMutationParams = {
  boardId?: number;
};

type MutationFnParams = Omit<PostPdfsRequestType, 'boardId'> & {
  boardId?: number;
};

export const usePostPdfs = (params?: UsePostPdfsMutationParams) => {
  const currentBoardId = useGetCurrentBoardId();
  const boardId = params?.boardId || currentBoardId;

  return useMutation({
    mutationFn: (param: MutationFnParams) =>
      postPdfs({
        boardId: boardId as number,
        ...param,
      }),
  });
};
